function JoinPia(config, renderer) {
  let pia
  let joinPiaButton

  $.extend(this, new Details(renderer))

  this.init = function () {
    let item = sessionStorage.getItem('pia')
    let storedPia = item ? JSON.parse(item) : undefined

    joinPiaButton = null
    pia = {
      isLuminorClient: false,
      id: null,
      account: null,
      amounts: calculateAmounts(),
      percentages: calculatePercentages(storedPia),
      authorize: true
    }

    return {
      assets: session.pension.secondPillar.assets,
      percentages: pia.percentages,
      hasLuminorPia: session.pension.investmentAccounts.hasLuminorPia,
      canAssignPiaAsActiveFund: config.canAssignPiaAsActiveFund
    }
  }

  function calculateAmounts() {
    let result = {}
    $.each(session.pension.secondPillar.assets, function(i, asset) {
      result[asset.fund.isin] = asset.amount
    })
    return result
  }

  function calculatePercentages(storedPia) {
    let percentages = {}
    $.each(session.pension.secondPillar.assets, function(i, asset) {
      if (storedPia && storedPia.percentages[asset.fund.isin]) {
        percentages[asset.fund.isin] = storedPia.percentages[asset.fund.isin]
      }
      else {
        percentages[asset.fund.isin] = 100
      }
    })
    return percentages
  }

  this.done = function () {
    joinPiaButton = $('#join-pia')
    if (!session.pension.investmentAccounts.hasLuminorPia) {
      createPiaDraft()
      $('[name="authorize"]').on('change', onCheckboxChanged)
      $('#distribution').on('keyup change', '[name="assetSellPercent"]', validateSellPercent)
    }

    Object.entries(pia.percentages).forEach((k) => {
      let input = $('#distribution').find('[data-isin="' + k[0] + '"]')
      input.val(k[1]);
      validateSellPercent({target: input});
    })
  }

  function onCheckboxChanged(e) {
    pia.authorize = e.target.checked
  }

  function toggleSubmitButton() {
    let isFormValid = !!pia.isLuminorClient && !!pia.id
    $.each(pia.percentages, function(i, assetPercentage) {
      isFormValid = isFormValid && isValidPercentage(assetPercentage)
    })

    if (isFormValid) {
      joinPiaButton.removeAttr('disabled')
    }
    else {
      joinPiaButton.attr('disabled', true)
    }
  }

  function createPiaDraft() {
    Fetch.post('/application/second-pillar/pia/create-draft', {})
      .then(
        function (result) {
          pia.isLuminorClient = result['isLuminorClient']
          pia.id = result['piaId']
          pia.account = result['account']

          $("#loading-PIA").addClass("d-none");
          joinPiaButton.on('click', openNextPage)
          toggleSubmitButton()
          if (!pia.isLuminorClient) {
            $('.for-non-luminor-client').removeClass('d-none')
            joinPiaButton.addClass('d-none')
          }
        },
        function (failure) {
          $("#loading-PIA").addClass("d-none")
          $('#error-messages pre').text(failure && failure['error'] || Labels['pia-creation-failed'])
          $('#error-messages').removeClass('d-none')
        });
  }

  function openNextPage() {
    sessionStorage.setItem('pia', JSON.stringify({
      id: pia.id,
      account: pia.account,
      amounts: pia.amounts,
      percentages: pia.percentages,
      authorize: pia.authorize
    }))

    location.href = '#piasigning'
  }

  function isValidPercentage(value) {
    return !isNaN(value) && value >= 0 && value <= 100
  }

  function validateSellPercent(e) {
    const input = $(e.target);
    const assetRow = input.closest('.js-asset-row')
    const newPercentage = parseInt(input.val())
    const isin = input.attr('data-isin')
    const amount = pia.amounts[isin]
    pia.percentages[isin] = newPercentage

    if (input.val().match(/^\d+$/) && isValidPercentage(newPercentage)) {
      assetRow.removeClass('has-danger')
      assetRow.find('.js-asset-sell-amount').text(Formats.amountWithCurrency(amount * newPercentage / 100))
    }
    else {
      assetRow.addClass('has-danger')
      assetRow.find('.js-asset-sell-amount').text('')
    }
    toggleSubmitButton()
  }
}